<mat-accordion class ="custom-accordion">
    <mat-expansion-panel class ="custom-panel" (click)="click()" hideToggle>
        <mat-expansion-panel-header class ="custom-header" >
        	<span class="text-description">
            	{{ textoExpansion  + '.normal' | translate }}
                <a class="more-information" target="_blank">
                	{{ text | translate }}
                </a>
            </span>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <span class="text-description">
                <p> {{ textoExpansion + '.expanded'  | translate }}</p>
            </span>
        </ng-template>
    </mat-expansion-panel>
</mat-accordion>
